import React, { useEffect, useRef, useState } from "react";
import MuiPopover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from '@mui/material/Box'

const Popover = ({
  className,
  trigger,
  refExit,
  hide,
  content,
  ...providedProps
}) => {
  const [isOpen, open] = useState(false);
  const anchorEl = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const shouldHide = typeof hide === "boolean" ? hide : false;
      if (shouldHide) {
        open(false);
      }
    }
  }, [hide, isOpen, open]);

  const handleClick = (event) => {
    anchorEl.current = event.currentTarget;
    open(true);
  };

  const handleRequestClose = (e) => {
    e.stopPropagation();

    open(false);
  };

  const closeIconClass = providedProps?.classes?.closeIcon;
  delete providedProps?.classes.closeIcon; // remove non-standard class from being passed to the popover component

  const transformOriginSpecs = {
    vertical: "top",
    horizontal: "center",
  };

  const anchorOriginSpecs = {
    vertical: "bottom",
    horizontal: "center",
  };

  const handleOnExit = () => {
    if (refExit) {
      refExit();
    }
  };

  const triggerProps = {
    key: "content",
    onClick: (event) => {
      event.stopPropagation();

      if (trigger.props.onClick) trigger.props.onClick();
      handleClick(event);
    },
  };

  return (
    <>
      <span {...triggerProps}>{trigger}</span>
      <MuiPopover
        elevation={2}
        open={isOpen}
        TransitionProps={{ onExited: handleOnExit }}
        onClose={handleRequestClose}
        anchorEl={anchorEl.current}
        anchorOrigin={anchorOriginSpecs}
        transformOrigin={transformOriginSpecs}
        {...providedProps}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <IconButton
            aria-label="Close"
            onClick={handleRequestClose}
            className={closeIconClass}
            style={{
              position: "sticky",
              margin: '4px 4px -45px auto',
              marginLeft: "auto",
              left: "4px",
              top: "4px",
              zIndex: "1000",
            }}
          >
            <CloseIcon />
          </IconButton>
        {content}
        </Box>
      </MuiPopover>
    </>
  );
};

export default Popover;
